import { render } from "./CIS-Tabs-Secondary.vue?vue&type=template&id=014c4554&scoped=true"
import script from "./CIS-Tabs-Secondary.vue?vue&type=script&lang=js"
export * from "./CIS-Tabs-Secondary.vue?vue&type=script&lang=js"

import "./CIS-Tabs-Secondary.vue?vue&type=style&index=0&id=014c4554&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-014c4554"]])

export default __exports__